var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view--wallpapers"},[_c('wallpaper-list',{attrs:{"selectable":false,"show-bulk-actions":true,"show-filters":{ 'category': true },"show-actions":true,"show-paging":true,"show-title":false}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ef79a00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/wallpapers/Index.vue
// module id = OACa
// module chunks = 0